import React from 'react';
import { observer } from 'mobx-react';
import { IAddressProps } from './index';

export const AddressStreetFormat = observer((props: IAddressProps) => {
  const { addressInputs } = props;

  return (
    <div>
      {addressInputs.addressInput}
      <div className={'container-two-columns'}>
        {addressInputs.streetNumberInput}
        {addressInputs.neighborhoodInput}
      </div>

      <div className={'container-two-columns'}>
        {addressInputs.floorInput}
        {addressInputs.apartmentInput}
      </div>

      <div className={'container-two-columns'}>
        {addressInputs.cityInput}
        {addressInputs.stateDropDownInput}
      </div>

      <div className={'container-two-columns'}>
        {addressInputs.zipCodeInput}
        {addressInputs.countryInput}
      </div>
    </div>
  );
});
